"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_draggable_1 = __importDefault(require("react-draggable"));
var styles_1 = require("@material-ui/core/styles");
var DragIndicator_1 = __importDefault(require("@material-ui/icons/DragIndicator"));
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var typography = _a.typography, spacing = _a.spacing;
    return ({
        dragHandle: {
            cursor: 'col-resize'
        },
        icon: {
            transform: "translate(0, ".concat(spacing(0.25), "px) !important"),
            fontSize: typography.body1.fontSize
        }
    });
});
var DraggableIcon = function (props) {
    var handlerColumnWidth = props.handlerColumnWidth, columnId = props.columnId, width = props.width, columnIndex = props.columnIndex;
    var innerClasses = useStyles();
    var handlerDraggable = (0, react_1.useCallback)(function (event, _a) {
        var deltaX = _a.deltaX;
        event.stopPropagation();
        event.preventDefault();
        handlerColumnWidth({
            columnIndex: columnIndex,
            columnId: columnId,
            deltaX: deltaX,
            width: width
        });
    }, [columnIndex, columnId, width, handlerColumnWidth]);
    return (react_1.default.createElement("span", { role: "button", tabIndex: 0, onMouseDown: function (e) { return e.stopPropagation(); } },
        react_1.default.createElement(react_draggable_1.default, { axis: "x", defaultClassName: innerClasses.dragHandle, onDrag: handlerDraggable, position: { x: 0, y: 0 }, defaultPosition: { x: 0, y: 0 } },
            react_1.default.createElement(DragIndicator_1.default, { classes: { root: innerClasses.icon } }))));
};
exports.default = DraggableIcon;
